import * as React from 'react';
export const vippsSvg = React.forwardRef(function vippsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FF5B24',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M19.924 13.174c1.398 0 2.596-1.061 2.596-2.587C22.52 9.061 21.322 8 19.924 8c-1.398 0-2.596 1.061-2.596 2.587 0 1.526 1.198 2.587 2.596 2.587Zm3.395 4.18c-1.732 2.255-3.562 3.815-6.791 3.815-3.294 0-5.857-1.99-7.854-4.91-.8-1.194-2.03-1.46-2.93-.829-.831.597-1.03 1.858-.266 2.953 2.763 4.212 6.59 6.666 11.05 6.666 4.094 0 7.29-1.99 9.786-5.307.931-1.227.898-2.487 0-3.184-.833-.664-2.064-.43-2.995.796Z',
      fill: '#fff',
    }),
  );
});
vippsSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vipps = {
  category: 'brand',
  colorable: false,
  name: 'vipps',
  svg: vippsSvg,
};
